import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=3fc54e08&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"
import style0 from "./Positions.vue?vue&type=style&index=0&id=3fc54e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc54e08",
  null
  
)

export default component.exports